import { HAVuePlugin } from "@k4connect/project-merlin-shared-home-automation";
import "@k4connect/project-merlin-shared-home-automation/src/assets/Grid.scss";

export default HAVuePlugin;
